import axiosInstance from '../helpers/axiosInstance'

// Batches above the backend's inline threshold are handed to a worker and answered
// with 202 + a task id, so the request itself no longer waits on SAP. A small
// batch still answers inline within a couple of SAP calls; the old 600s client
// timeout was unreachable anyway — the Heroku router closes the request at 30s.
const EXECUTE_TIMEOUT_MS = 60_000

const BASE = `${process.env.REACT_APP_PLATFORM_URL}/api/v1/natura-operations/deposit-transfers`

export const fetchOptions = async () => {
  const { data } = await axiosInstance.get(`${BASE}/options`)
  return data
}

export const previewDepositTransfer = async payload => {
  const { data } = await axiosInstance.post(`${BASE}/preview`, payload)
  return data
}

// Resolves either to the finished result (inline) or to { status: "processing",
// task_id } — poll fetchExecuteTaskStatus in that case.
export const executeDepositTransfer = async payload => {
  const { data } = await axiosInstance.post(BASE, payload, { timeout: EXECUTE_TIMEOUT_MS })
  return data
}

export const fetchExecuteTaskStatus = async taskId => {
  const { data } = await axiosInstance.get(`${BASE}/execute-tasks/${taskId}`)
  return data
}
